import { shiftControlConstants } from "../constant/shiftControl.constants";

export const initialState = {
    dataShiftControl: [
    ],
    errorCode: '',
    successCode: '',
    isLoading: false
};
const shiftControlReducer = (state = initialState, action) => {
    switch (action.type) {
        case shiftControlConstants.GET_SUCCESS:
            return {
                ...state,
                errorCode: action.shiftControlList.error_code,
                dataShiftControl: action.shiftControlList.result,
            }; 
        default:
            return state;
    }
};

export default shiftControlReducer;
